<template>
    <div class="feight-manager">
        <div class="btn-box" style="text-align: left;"><a-button @click="showAdd">添加郵費模板</a-button></div>
        <a-table :data-source="list" row-key="id">
            <a-table-column
                    align="left"
                    title="郵費名稱"
                    data-index="templateName">
            </a-table-column>
            <a-table-column
                    align="left"
                    title="是否包郵">
                <template slot-scope="row,item">
                    {{item.isFreight ? '是' : '否'}}
                </template>
            </a-table-column>
            <a-table-column
                    align="left"
                    title="郵費詳情">
                <template slot-scope="row,item">
                    <ul class="freight-list" style="padding-left:0;" v-if="item.templateDetail">
                        <li style="font-size: 12px;" class="freight-item" v-for="(sub,sIndex) in item.templateDetail" :key="sIndex">
                            <div class="top">{{sub.areaList}}</div>
                            <div class="bottom">{{sub.freight}}</div>
                        </li>
                    </ul>
                    <span v-else>包郵</span>
                </template>
            </a-table-column>
            <a-table-column
                    align="left"
                    title="操作">
                <template slot-scope="row,item">
                    <a-space>
                        <a-button type="danger" size="small" @click="edit(item)">編輯</a-button>
                        <a-button type="primary" size="small" @click="del(item)">刪除</a-button>
                    </a-space>
                </template>
            </a-table-column>
        </a-table>
        <a-modal
                :maskClosable="false"
                :width="800"
                :title="editor ? '編輯' : '添加'"
                :visible="addShow"
                :confirm-loading="confirmLoading"
                @ok="sub"
                @cancel="cancel"
        >
            <a-form>
                <a-form-item
                        label="模板名稱"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 12 }"
                        required
                >
                    <a-input placeholder="請輸入郵費模板名稱" :maxLength="10" v-model="templateName"></a-input>
                </a-form-item>
                <a-form-item
                        label="發貨地址"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 14 }"
                        required
                >
                    <a-cascader :options="options" @change="addressChange" placeholder="省市區選擇" v-model="addrList"/>
                    <br>
                    <a-input placeholder="請輸入詳細地址" v-model="addressDetail"></a-input>
                </a-form-item>
                <a-form-item
                        label="是否包郵模板"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 14 }"
                        required
                >
                    <a-switch v-model="isFreight" />
                    <span style="margin-left:20px;">{{isFreight?'是':'否'}}</span>
                </a-form-item>
                <a-form-item
                        v-if="!isFreight"
                        label="模板名稱"
                        :label-col="{ span: 5 }"
                        :wrapper-col="{ span: 18 }"
                        required
                >
                    <ul class="list" style="padding:0;" v-if="choiceList.length">
                        <li style="margin-bottom:10px;width:400px;list-style: none; border-right: 1px solid #ccc; position: relative;border:1px solid #ccc;padding:10px;border-radius: 10px;" v-for="(item,index) in choiceList" :key="index">
                            <div class="top" style="margin-bottom:20px;line-height: 16px;font-size: 12px;">區域：<span v-for="(sub,sIndex) in item.areas" :key="sIndex">{{sub.provinceName}}<span v-if="sIndex < item.areas.length - 1"> / </span></span></div>
                            <div style="line-height: 16px;font-size: 12px;" class="bottom" v-if="!item.isFreight">
                                郵費信息：基礎郵費：每{{item.basicUnit}}kg,{{item.basicFee}}元，每增加{{item.addUnit}}kg,增加{{item.addFee}}元
                            </div>
                            <div style="line-height: 16px;font-size: 12px;" class="bottom" v-else>郵費信息：包郵</div>
                            <a-space class="btn-box">
                                <a-button type="primary" size="small" @click="editAddr(item,index)">編輯</a-button>
                                <a-button type="danger" size="small" @click="delAddr(index)">刪除</a-button>
                            </a-space>
                        </li>
                    </ul>
                    <a-button @click="showAddr">添加區域模板</a-button>
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal
                :maskClosable="false"
                :width="800"
                :title="addrEditor ? '編輯' : '添加'"
                :visible="addrShow"
                @ok="addAddr"
                @cancel="addrCancel"
        >
            <a-form-item
                    label="選擇區域"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 18 }"
                    required
            >
                <a-checkbox-group v-model="addrChecked">
                    <a-row>
                        <a-col :span="8" v-for="(item,index) in areaOptions" :key="index"><a-checkbox :disabled="item.isDisabled" :value="item.id">{{item.name}}</a-checkbox></a-col>
                    </a-row>
                </a-checkbox-group>
            </a-form-item>
            <a-form-item
                    label="區域是否包郵"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 18 }"
                    required
            >
                <a-switch v-model="isChecked" />
                <span style="margin-left:20px;">{{isChecked?'是':'否'}}</span>
            </a-form-item>
            <a-form-item
                    v-if="!isChecked"
                    label="區域郵費"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 18 }"
                    required
            >
                基礎郵費：每<a-input style="width:60px;" v-model="basicUnit"></a-input> kg,<a-input style="width:60px;" v-model="basicFee"></a-input>元，每增加<a-input style="width:60px;" v-model="addUnit"></a-input>kg,增加<a-input style="width:60px;" v-model="addFee"></a-input>元
            </a-form-item>
        </a-modal>
    </div>
</template>
<script>
    import { areaList } from '../../components/areaList';
    export default {
        data() {
            return {
                addrChecked:[],
                addrEditor:false,
                addrShow:false,
                isFreight:false,
                addrList:[],
                addressDetail:undefined,
                list:[],
                tableLoading:false,
                editObj:null,
                editor:false,
                addShow:false,
                confirmLoading:false,
                templateName:undefined,
                options:areaList,
                areaOptions:[],
                isChecked:false,
                basicUnit:undefined,
                basicFee:undefined,
                addUnit:undefined,
                addFee:undefined,
                choiceList:[],
                choiceEditor:false,
                editIndex:undefined,
                addressList:[]
            }
        },
        methods: {
            del(item){
                let self=this;
                this.$Confirm({
                    title:'確定刪除嗎？',
                    onOk(){
                        return new Promise((resolve,reject)=>{
                            self.$http({
                                method: 'post',
                                url: '/manager/product/freight/delete',
                                data:{
                                    id:item.id
                                }
                            }).then(function(res){
                                self.$Message.success('操作成功')
                                self.getList()
                                resolve()
                            }).catch(err=>{
                                resolve()
                            })
                        })
                    },
                    onCancel(){
                    }
                })
            },
            addressChange(list,big){
                this.addressList=big ? big : [];
            },
            getList(){
                let self=this;
                self.tableLoading=true;
                self.$http({
                    method: 'post',
                    url: '/manager/product/freight/list',
                    data:{
                        pageIndex:1,
                        pageSize:100
                    }
                }).then(res=>{
                    res.data.forEach(item=>{
                        if(item.templateDetail){
                            item.templateDetail.forEach(sub=>{
                                let arr=[]
                                sub.areas.forEach(s=>{
                                    arr.push(s.provinceName)
                                })
                                sub.areaList=arr.join(',');
                                if(!sub.isFreight){
                                    sub.freight=`基礎郵費：每${(sub.basicUnit / 1000).toFixed(2)}kg,${(sub.basicFee / 100).toFixed(2)}元；後續郵費：每增加${(sub.addUnit / 1000).toFixed(2)}kg,增加${(sub.addFee / 100).toFixed(2)}元`;
                                }else{
                                    sub.freight='包郵'
                                }
                            })
                        }
                    })
                    self.list=res.data ? res.data : []
                    console.log(list)
                    self.tableLoading=false;
                }).catch(err=>{
                    self.tableLoading=false;
                })
            },
            validate(){
                if(this.templateName === '' || !this.templateName){
                    this.$Message.warning('請輸入模板名稱');
                    return false;
                }
                if(!this.addrList.length || !this.addrList){
                    this.$Message.warning('請選擇省市區');
                    return false;
                }
                if(!this.addressDetail || this.addressDetail === ''){
                    this.$Message.warning('請輸入詳細地址');
                    return false;
                }
                if(!this.isFreight && !this.choiceList.length){
                    this.$Message.warning('請添加區域運費');
                    return false;
                }
                return true;
            },
            getSubData(){
                let data={
                    isFreight: this.isFreight,
                    senderAddress: {
                        addressDetail: this.addressDetail,
                        cityCode: this.addressList[1].value,
                        cityName: this.addressList[1].label,
                        districtCode: this.addressList[2] ? this.addressList[2].value : undefined,
                        districtName: this.addressList[2] ? this.addressList[2].label : undefined,
                        provinceCode: this.addressList[0].value,
                        provinceName: this.addressList[0].label
                    },
                    templateDetail: [],
                    templateName:this.templateName
                }
                if(this.isFreight){
                    delete data.templateDetail
                }else{
                    data.templateDetail=this.choiceList;
                }
                data.templateDetail.forEach(item=>{
                    item.addFee=item.addFee * 100;
                    item.addUnit=item.addUnit * 1000;
                    item.basicFee=item.basicFee * 100;
                    item.basicUnit=item.basicUnit * 1000;
                })
                return data;
            },
            sub(){
                let self=this;
                if(!this.validate()){return false;}
                let data=this.getSubData()
                data.templateDetail.forEach(item=>{
                    delete item.areaList;
                    delete item.freight;
                    if(item.isFreight){
                        delete item.addUnit;
                        delete item.addFee;
                        delete item.basicUnit;
                        delete item.basicFee;
                    }
                })
                let url=''
                if(this.editor){
                    url='/manager/product/freight/update'
                    data.id=this.editObj.id;
                }else{
                    url='/manager/product/freight/add'
                    delete data.id;
                }
                console.log(JSON.stringify(data))
                self.confirmLoading=true;
                self.$http({
                    method: 'post',
                    url:url,
                    data:data
                }).then(res=>{
                    self.$Message.success('操作成功');
                    self.getList();
                    self.confirmLoading=false;
                    self.cancel()
                    self.addrCancel()
                }).catch(err=>{
                    // self.$Message.error(JSON.stringify(err))
                    self.confirmLoading=false;
                })
            },
            edit(item){
                this.editObj=item;
                this.editor=true;
                this.isFreight=item.isFreight;
                this.addressDetail=item.senderAddress.addressDetail;
                this.templateName=item.templateName;
                this.addrList=[item.senderAddress.provinceCode,item.senderAddress.cityCode,item.senderAddress.districtCode ? item.senderAddress.districtCode : undefined]
                let obj=[
                    {value:item.senderAddress.provinceCode, label:item.senderAddress.provinceName},
                    {value:item.senderAddress.cityCode, label:item.senderAddress.cityName}
                    ]
                if(item.senderAddress.districtCode){
                    obj.push({
                        value:item.senderAddress.districtCode,
                        label:item.senderAddress.districtName
                    })
                }
                if(item.templateDetail){
                    item.templateDetail.forEach(item=>{
                        item.addFee = item.addFee / 100;
                        item.addUnit = item.addUnit / 1000;
                        item.basicFee = item.basicFee / 100;
                        item.basicUnit = item.basicUnit / 1000;
                    })
                    this.choiceList=item.templateDetail
                }
                this.addressList=obj;
                this.addShow=true;
            },
            cancel(){
                this.addShow=false;
                this.templateName=undefined;
                this.addrList=[]
                this.addressList=[]
                this.addressDetail=undefined;
                this.editor=false;
                this.choiceList=[];
                this.editObj=null;
                this.addrCancel();
            },
            showAdd(){
                this.addShow=true;
                this.editor=false;
                this.editObj=null;
            },
            addAddr(){
                if(!this.addrChecked.length){
                    this.$Message.warning('請選擇區域');
                    return false;
                }
                if(!this.isChecked){
                    if(this.basicUnit === '' || !this.basicUnit){
                        this.$Message.warning('基礎重量不能為空');
                        return false;
                    }
                    if(this.basicFee === '' || !this.basicFee){
                        this.$Message.warning('基礎運費不能為空');
                        return false;
                    }
                    if(this.addUnit === '' || !this.addUnit){
                        this.$Message.warning('後續重量不能為空');
                        return false;
                    }
                    if(this.addFee === '' || !this.addFee){
                        this.$Message.warning('後續運費不能為空');
                        return false;
                    }
                }
                let obj={
                    areas: [],
                    isFreight: this.isChecked
                }
                this.areaOptions.forEach(item=>{
                    this.addrChecked.forEach(sub=>{
                        if((item.id * 1 === sub * 1) && !item.isDisabled){
                            obj.areas.push({
                                provinceCode: item.id,
                                provinceName: item.name
                            })
                        }
                    })
                })
                console.log(obj.areas)
                if(!obj.areas.length){
                    this.$Message.warning('請選擇區域');
                    return false;
                }
                if(!this.isChecked){
                    obj.addFee= this.addFee
                    obj.addUnit= this.addUnit
                    obj.basicFee= this.basicFee
                    obj.basicUnit= this.basicUnit
                }else{
                    delete obj.addFee
                    delete obj.addUnit
                    delete obj.basicFee
                    delete obj.basicUnit
                }
                if(this.choiceEditor){
                    this.choiceList[this.editIndex]=obj;
                }else{
                    this.choiceList.push(obj)
                }
                this.addrCancel()
                console.log(this.choiceList)
            },
            showAddr(){
                this.addrShow=true;
                this.choiceList.forEach(item=>{
                    item.areas.forEach(sItem=>{
                        this.areaOptions.forEach(sub=>{
                            if(sub.id * 1 === sItem.provinceCode * 1){
                                sub.isDisabled=true;
                                this.addrChecked.push(sub.id)
                            }
                        })
                    })
                })
                console.log(this.areaOptions)
            },
            addrCancel(){
                this.addrEditor=false;
                this.addrShow=false;
                this.addrChecked=[];
                this.isChecked=false;
                this.addFee=undefined;
                this.addUnit=undefined;
                this.basicFee=undefined;
                this.choiceEditor=false;
                this.editIndex=undefined;
                this.basicUnit=undefined;
                this.areaOptions.forEach(sub=>{
                    sub.isDisabled=false;
                })
            },
            editAddr(item,index){
                this.choiceList.forEach(bItem=>{
                    bItem.areas.forEach(sItem=>{
                        this.areaOptions.forEach(sub=>{
                            if(sub.id * 1 === sItem.provinceCode * 1){
                                sub.isDisabled=true;
                                this.addrChecked.push(sub.id)
                            }
                        })
                    })
                })
                item.areas.forEach(bItem=>{
                    this.areaOptions.forEach(sub=>{
                        if(sub.id * 1 === bItem.provinceCode * 1){
                            console.log(bItem.provinceName)
                            sub.isDisabled=false;
                        }
                    })
                })
                this.editIndex=index;
                if(!item.isFreight){
                    this.basicUnit=item.basicUnit
                    this.basicFee=item.basicFee
                    this.addUnit=item.addUnit
                    this.addFee=item.addFee
                }
                this.choiceEditor=true;
                this.isChecked=item.isFreight
                this.addrShow=true;
            },
            delAddr(index){
                this.choiceList.splice(index,1)
            }
        },
        created() {
            this.getList();
            //複製一份省數據，加上選中狀態
            areaList.forEach(item=>{
                this.areaOptions.push({name:item.label,id:item.value,isDisabled:false})
            })
            this.$emit('breadcrumbChange',['商品管理','郵費設置'])
        },
    }
</script>
<style lang="less">
    .feight-manager{

    }
</style>